<template>
    <section class="mt-16">
        <v-breadcrumbs
          large
          :items="crumbs"
          divider="/"
          class="pl-0"
        ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-currency-eur</v-icon> <span>Atualizar despesa</span>
        </h1>
  
        <div class="mt-16">
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
          <Despesa v-else method="update" :despesa="despesa"></Despesa>
        </div>
    </section>
  </template>
  <script>
  import DespesasAPI from "@/api/Despesas.js";
  import Despesa from '@/components/Despesas/Despesas.vue'
  
  export default {
    components: {
        Despesa
    },
    beforeCreate(){
      document.title = "ODC - Atualizar despesa";	
    },
    data: () => ({
        despesa: {},
        loading:true
    }),
    mounted(){
      if(!this.$store.getters.hasPermission(['super', 'expenses.update'])){
        this.$router.push('/no-permission');
      }
  
      DespesasAPI.find(this.$route.params.id).then(({data}) => { this.despesa = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: 'Dashboard',
            disabled: false,
            to: '/admin',
            exact: true,
          },
          {
            text: 'Atualizar despesa',
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
};
</script>
  